import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "15",
  fill: "none",
  viewBox: "0 0 20 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.305 14.656h13.382c1.688 0 2.563-.867 2.563-2.531V2.609c0-1.664-.875-2.53-2.562-2.53H3.305C1.617.078.742.937.742 2.608v9.516c0 1.664.875 2.531 2.563 2.531m.093-1.531c-.726 0-1.125-.375-1.125-1.133v-9.25c0-.758.399-1.14 1.125-1.14h13.196c.718 0 1.125.382 1.125 1.14v9.25c0 .758-.407 1.133-1.125 1.133zM6.852 7.32c.937.008 1.687-.78 1.687-1.836 0-.984-.75-1.804-1.687-1.804-.93 0-1.688.82-1.688 1.804 0 1.055.758 1.836 1.688 1.836m5.007-2.468h4.055c.29 0 .5-.22.5-.5a.48.48 0 0 0-.5-.485H11.86c-.289 0-.5.211-.5.485 0 .28.211.5.5.5m0 3.015h4.055c.29 0 .5-.219.5-.5a.487.487 0 0 0-.5-.492H11.86c-.289 0-.5.219-.5.492 0 .281.211.5.5.5m-7.953 3.008h5.89c.282 0 .43-.195.43-.453 0-.727-1.07-2.578-3.374-2.578s-3.368 1.851-3.368 2.578c0 .258.141.453.422.453m7.953 0h4.055c.29 0 .5-.21.5-.484a.495.495 0 0 0-.5-.508H11.86c-.289 0-.5.226-.5.508 0 .273.211.484.5.484"
    }, null, -1)
  ])))
}
export default { render: render }